export default "__VITE_ASSET__BL2R_z$S__"